module.exports = __webpack_public_path__ + "h5/img/milestone-global.c05da3fa.jpg";